import { PaginationRequest } from '../config/common';

export class PaginationExceptionCodeRequest extends PaginationRequest {
    code?: string = '';
    description?: string ='';
    chargeType?: number;
    surchargeID?: string;
}

export interface CreateExceptionCodeRequest {
    code?: string;
    description?: string;
    chargeType?: number ;
    surchargeID?: string; 
}
